export enum OrderCategory {
  new = 'new',
  processed = 'processed',
  active = 'active',
  archived = 'archived',
}
